import type NotifJE from "parog-web/models/notification-triggered-journal-event";

function bioExamResultNotifications<T extends NotifJE>(
  notifications: T[]
): T[] {
  return notifications.filter(
    je => je.triggeringJournalEventType === "BioExamResultsReceivedJournalEvent"
  );
}

/**
 * Group BioExamResults notification.
 * @return the notifications grouped by BioExamResultsJE
 */
function groupBioExamNotifications<T extends NotifJE>(
  notifications: T[]
): Record<string, T[]> {
  const bioExamResultNotifs = bioExamResultNotifications(notifications);
  const grouped = bioExamResultNotifs.reduce<Record<string, T[]>>(
    (acc, notif) => {
      const id = notif.triggeringJournalEventId;
      if (!id) return acc;
      (acc[id] ||= []).push(notif);
      return acc;
    },
    {}
  );

  for (const notifs of Object.values(grouped)) {
    notifs.sort((a, b) => b.occurredAt.getTime() - a.occurredAt.getTime());
  }

  //only keep notification groups that have at least one unprocessed notification.
  const filtered = Object.fromEntries(
    Object.entries(grouped).filter(([_, notifs]) =>
      notifs.some(n => n.isUnprocessed === true)
    )
  );

  return filtered;
}

/**
 * Group BioExamResults notification.
 * @return most recent notifications from a notification group
 */
function mostRecentBioNotifications<T extends NotifJE>(
  groupednotifications: Record<string, T[]>
): T[] {
  return Object.values(groupednotifications).map(notifs => notifs[0]);
}

/**
 * @return all unprocessed bio notifications that are displayed.
 */
function unprocessedBioNotifications<T extends NotifJE>(
  groupednotifications: Record<string, T[]>
): T[] {
  return Object.values(groupednotifications)
    .flat()
    .filter(notif => notif.isUnprocessed);
}

export {
  groupBioExamNotifications,
  mostRecentBioNotifications,
  unprocessedBioNotifications
};
